// extracted by mini-css-extract-plugin
export default {"zoomModal":"f2-z"};